/* Welche Dateien eines Drops auf den Server gehören und was mit ihnen geschehen soll (ohne DOM, node-testbar).
 * Bekannte Arten: Sprites (.spr), Modelle (.mdl), Sounds und Skybox-Seiten (.tga). WADs und FGDs haben eigene Abgleiche (siehe mapwads.ts, mapfgd.ts). */
import Skybox from '../formats/skybox.ts';
import Backend from './backend.ts';
import { isSoundFile } from './sounds.ts';

export interface DroppedFile { name: string; rel?: string; hash: string }
export interface ServerFile { path: string; sha256?: string; owner?: string }
export type DropSync = 'upload' | 'same' | 'differs';
export interface DropPlan { name: string; path: string; kind: DropSync; owner?: string }

/** Gehört die Datei zu einer Art, die beim Ziehen in den Editor automatisch hochgeladen wird? */
export function isAutoUpload(fileName: string): boolean {
  const n = String(fileName || '').replace(/^.*[\\/]/, '');
  if (/\.(spr|mdl)$/i.test(n) || isSoundFile(n)) return true;
  return /\.tga$/i.test(n) && !!Skybox.nameOf(n);
}

const norm = (p: string): string => p.toLowerCase();

/** Je Datei: hochladen (fehlt), gleich (gleicher Inhalt) oder anders (gleicher Pfad, anderer Inhalt). Nicht bekannte Dateien fehlen im Ergebnis. */
export function planDroppedUploads(files: DroppedFile[], assets: ServerFile[]): DropPlan[] {
  const byPath = new Map(assets.map((a) => [norm(a.path), a]));
  const out: DropPlan[] = [];
  for (const f of files) {
    if (!isAutoUpload(f.name)) continue;
    const path = Backend.targetPath(f.name, f.rel);
    const it = byPath.get(norm(path));
    if (!it) out.push({ name: f.name, path, kind: 'upload' });
    else if (f.hash && it.sha256 && f.hash !== it.sha256) out.push({ name: f.name, path: it.path, kind: 'differs', owner: it.owner });
    else out.push({ name: f.name, path: it.path, kind: 'same' });
  }
  return out;
}
